VjsAdmin.CleverSyncForm = (function () {
    const init = function () {
        VjsAdmin.initDateRangePickers($('#cleversync-form'));

        // convert database date from UTC to local time in format MM/DD/YYYY
        if (typeof $('#start_date').val() !== 'undefined' && $('#start_date').val() != null && $('#start_date').val() !== '') {
            $('#start_date').val(moment($('#start_date').val()).format('MM/DD/YYYY'));
        }
        if (typeof $('#end_date').val() !== 'undefined' && $('#end_date').val() != null && $('#end_date').val() !== '') {
            $('#end_date').val(moment($('#end_date').val()).format('MM/DD/YYYY'));
        }

        const updateFields = function () {
            const enabled = $('#cleversync-enabled').is(':checked');

            if (+enabled === 1) {
                // $('#cleversync-settings-container').removeClass('disabled');
                $('#cleversync-form #district-clever-id').prop('required', true);
                $('#cleversync-form #sso-instance-guid').prop('required', true);
            }

            if (+enabled === 0) {
                // $('#cleversync-settings-container').addClass('disabled');
                $('#cleversync-form input, #cleversync-form select').prop('required', false);
            }
        };

        $('#cleversync-enabled').on('change', updateFields);
        $('#clever-remove-rostering').on('click', (e) => {
            e.preventDefault();
            if (
                window.confirm(
                    'Are you sure you want to remove the connections?\n\n'
                        + 'This will remove all user and license rostering connection data.',
                )
            ) {
                const button = $('#clever-remove-rostering');
                const platformId = button.attr('data-platform-id');
                const districtGuid = button.attr('data-district-joint-guid');
                const connectionType = button.attr('data-connection-type');
                const req = new VjsUtility.Request();
                req.delete(`/platforms/${platformId}/districts/${districtGuid}/rostering/${connectionType}/`)
                    .done(() => {
                        VjsUtility.Notification.success('Rostering connections removed successfully!');
                    })
                    .fail((x) => {
                        VjsUtility.Notification.error(x.responseJSON.data);
                    });
            }
        });

        updateFields();
    };

    return {
        init,
    };
}());
